import { render } from "./DownGuardados.vue?vue&type=template&id=ffd5a098&scoped=true"
import script from "./DownGuardados.vue?vue&type=script&lang=js"
export * from "./DownGuardados.vue?vue&type=script&lang=js"

import "./DownGuardados.vue?vue&type=style&index=0&id=ffd5a098&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ffd5a098"

export default script